import React from 'react';
import ProductOverview from '../../product-overview/ProductOverview';
import product from '../all-gear.json';

const UAPerformanceHat = () => {
	return (
		<React.Fragment>
			<ProductOverview
				name={product.allGear[12].productName}
				color={product.allGear[12].color}
				size={product.allGear[12].sizes}
				price={product.allGear[12].price}
				img={product.allGear[12].img}
				miniImg1={product.allGear[12].miniImg1}
				miniImg2={product.allGear[12].miniImg2}
				miniImg3={product.allGear[12].miniImg3}
			/>
		</React.Fragment>
	);
};

export default UAPerformanceHat;
